import React from 'react'
import './index.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack'
import { GetMoreForLess } from './screens/GetMoreForLess'
import { GetMoreForLessForm } from './screens/GetMoreForLessForm'
import { StoreLocator } from './screens/StoreLocator'

const queryClient = new QueryClient()

const theme = createTheme({
  palette: {
    primary: {
      main: '#000'
    },
    secondary: {
      main: '#fff',
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  },
  typography: {
    fontFamily: 'Emprint',
    h1: {
      fontSize: '30px',
      fontWeight: '500',
      fontFamily: 'Emprint Bold'
    },
    h2: {
      fontSize: '1.25rem',
      fontWeight: '300'
    },
    h3: {
      fontSize: '18px',
      fontWeight: '200'
    },
    h4: {
      fontSize: '14px',
      fontWeight: '200',
      color: '#767676'
    },
    h5: {
      fontSize: '18px',
      fontWeight: '300',
      color: '#5A5A5A'
    },
    subtitle1: {
      fontSize: '22px',
      fontWeight: '300',
      fontFamily: "'Corsica MX Medium Cond',sans-serif"
    },
    subtitle2: {
      fontSize: '8px',
      fontWeight: '500',
      fontFamily: "'Corsica MX Medium Cond',sans-serif"
    },
    button: {
      fontWeight: '1000'
    }
  },
  components: {
    MuiStepLabel: { styleOverrides: { label: { fontSize: '17px' } } },
    MuiTypography: { styleOverrides: { caption: { fontSize: '15px' } } }
  }
})

const App = () => {
  return (
    <HelmetProvider>
      <SnackbarProvider>
        <Router>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider
              theme={{
                ...theme
              }}
            >
              <Routes>
                <Route path='/' element={<GetMoreForLess />} />
                <Route path='/register' element={<GetMoreForLessForm />} />
                <Route path='/mobilauthorizeddealers' element={<StoreLocator />} />
              </Routes>
            </ThemeProvider>
          </QueryClientProvider>
        </Router>
      </SnackbarProvider>
    </HelmetProvider>
  )
}

export default App
